// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { MutualFundFilters } from '@shared/data-access/interfaces/api/ai/mutual-funds';

export const MF_SCREENER_EXCLUDED_DEFAULT_LOCATION = 'United States';

export const mutualFundsScreenerInitialFilters: MutualFundFilters = {
  asset_class: ['Equity'],
  asset_manager: [],
  aum: '',
  category: [],
  currency: ['EUR'],
  location: [],
  max_nav: '',
  min_nav: '',
  max_expenses_ratio: '',
  min_expenses_ratio: '',
  segment: [],
  ter: '',
  text_search: '',
};

const sameStringList = (a?: string[], b?: string[]) => {
  const left = a ?? [];
  const right = b ?? [];
  return (
    left.length === right.length &&
    left.every((value, index) => value === right[index])
  );
};

const sameScalar = (
  a: string | number | undefined,
  b: string | number | undefined,
) => a === b;

export const isMutualFundsScreenerInitialState = (
  filters: MutualFundFilters,
): boolean => {
  const initial = mutualFundsScreenerInitialFilters;
  return (
    sameStringList(filters.asset_class, initial.asset_class) &&
    sameStringList(filters.asset_manager, initial.asset_manager) &&
    sameStringList(filters.category, initial.category) &&
    sameStringList(filters.currency, initial.currency) &&
    sameStringList(filters.location, initial.location) &&
    sameStringList(filters.segment, initial.segment) &&
    sameScalar(filters.aum, initial.aum) &&
    sameScalar(filters.ter, initial.ter) &&
    sameScalar(filters.text_search, initial.text_search) &&
    sameScalar(filters.min_nav, initial.min_nav) &&
    sameScalar(filters.max_nav, initial.max_nav) &&
    sameScalar(filters.min_expenses_ratio, initial.min_expenses_ratio) &&
    sameScalar(filters.max_expenses_ratio, initial.max_expenses_ratio)
  );
};

export const mutualFundLocationsExcludingDefault = (
  locations: string[],
): string[] =>
  locations.filter(loc => loc !== MF_SCREENER_EXCLUDED_DEFAULT_LOCATION);
